import React, {Component} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faInfoCircle, faTrash, faUserTimes} from "@fortawesome/pro-solid-svg-icons";

import styles from './AppointmentTable.css';
import moment from "moment";

export default class AppointmentTable extends Component {

    openAction(item) {
        const {openAppointment} = this.props;

        if(item.firstname && item.lastname && item.email) {
            openAppointment(item.firstname, item.lastname, item.email, (item.phone) ? item.phone : "", item.date);
        }
    }

    render() {
        const {cancelAction, deleteAction, appointments, openAppointment} = this.props;

        return (
            <div className={styles.wrapper}>
                <div className={styles.inner}>
                    <div className={styles.theadBackground}></div>
                    <table className={[styles.table, 'fixed_header'].join(' ')}>
                        <thead>
                        <tr>
                            <th><div className={styles.thInner}>Datum</div></th>
                            <th><div className={styles.thInner}>Uhrzeit</div></th>
                            <th><div className={styles.thInner}>Status</div></th>
                            <th><div className={styles.thInner}>Optionen</div></th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            appointments.map(item => {
                                return (
                                    <tr>
                                        <td>{moment(item.date).format('DD.MM.YYYY')}</td>
                                        <td>{moment(item.date).format('HH:mm')}</td>
                                        <td>{(item.status === 0) ? 'offen' : 'reserviert'}</td>
                                        <td>
                                            <a href={'#'} onClick={() => cancelAction(item.appointments_id)} title={"Stornieren"}>
                                                <FontAwesomeIcon icon={faUserTimes} color={'#444444'}/>
                                            </a>
                                            <a href={'#'} onClick={() => deleteAction(item.appointments_id)} title={"Löschen"}>
                                                <FontAwesomeIcon icon={faTrash} color={'#444444'}/>
                                            </a>
                                            <a href={'#'} onClick={() => this.openAction(item)} title={"Details"}>
                                                <FontAwesomeIcon icon={faInfoCircle} color={'#444444'}/>
                                            </a>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AppointmentTable/AppointmentTable.js